export class DestinationPoint {
  lat: number;
  lon: number;
  addr: string;
}
